import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { createReport } from '../api/reports.api';
import { REPORTS_QUERY_KEY } from '../constants/reports-query-keys';

export const useCreateReport = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: ({ name, scope }: { name: string; scope: 'ORG' | 'PRIVATE' }) =>
      createReport(name, scope),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: REPORTS_QUERY_KEY });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'authenticated.reports:toasts.createError');
    },
  });
};
